

export enum LOG_LEVELS {
    INFO = "INFO",
    WARN = "WARN",
    ERROR = "ERROR",
    DEBUG = "DEBUG",
}
export class JDebug {


    private static isEnabled: boolean = true;
    static passOrder: number = 0;
    private tag = 'TAG';
    static DEFAULT_LABEL: string = 'Debug';
    public static DEFAULT_LEVEL: LOG_LEVELS = LOG_LEVELS.DEBUG;
    private static _level :number=1;





    static enableDebugging(): void {
        JDebug.isEnabled = true;
    }

    static disableDebugging(): void {
        JDebug.isEnabled = false;
    }

    static TraceError(err: any) {
        this.traceObject(
            err,
            LOG_LEVELS.ERROR,
            getTextColor(LOG_LEVELS.ERROR)
        )
    }
    static logError(err: any) {
        this.logObject(err, "ERROR", LOG_LEVELS.ERROR)
    }

    static traceObject(obj: any, label: string = JDebug.DEFAULT_LABEL, color: string = 'black'): void {
        if (!JDebug.isEnabled || JDebug._level !=1) {
            return;
        }
        console.log(`%c--- ${label} ---`, `color: ${color}`);
        console.log(obj);
        console.log('------------------');
    }

    static logObject(obj: any, label: string = JDebug.DEFAULT_LABEL, level: LOG_LEVELS = JDebug.DEFAULT_LEVEL): void {
        if (!JDebug.isEnabled || JDebug._level !=1) {
            return;
        }
        const color: string = getTextColor(level);
        console.log(`%c[${label}]`, `color: ${color}`, obj);
    }

    static logArray(arr: any[], label: string = JDebug.DEFAULT_LABEL, level: LOG_LEVELS = JDebug.DEFAULT_LEVEL): void {
        if (!JDebug.isEnabled || JDebug._level !=1) {
            return;
        }
        const color: string = getTextColor(level);
        console.log(`%c[${label}]`, `color: ${color}`, arr);
    }

    static logTab(arr: any[], label: string = JDebug.DEFAULT_LABEL, level: LOG_LEVELS = JDebug.DEFAULT_LEVEL): void {
        if (!JDebug.isEnabled || JDebug._level !=1) {
            return;
        }
        //this.logArray(arr, label, level);
        const color: string = getTextColor(level);
        console.log(`%c[${label}]`, `color: ${color}`, arr);
        console.table(arr);
    }

    static logValue(value: any, label: string = JDebug.DEFAULT_LABEL, level: LOG_LEVELS = JDebug.DEFAULT_LEVEL): void {
        if (!JDebug.isEnabled || JDebug._level !=1) {
            return;
        }
        const color: string = getTextColor(level);
        console.log(`%c[${label}]`, `color: ${color}`, value);
    }

    static elevatedTag(tag: string = 'TAG', level: LOG_LEVELS = JDebug.DEFAULT_LEVEL, resetPassage: boolean = false): void {


        if (tag !== 'TAG') tag = `TAG-${tag}`;

        console.log(`[${tag} - Passage ${++JDebug.passOrder}]`, `Level: ${level}`);

        if (resetPassage) {
            JDebug.resetPassOrder();
        }
    }

    static tag(tag: string = 'TAG', level: LOG_LEVELS = JDebug.DEFAULT_LEVEL, resetPassage: boolean = false): void {
        if (!JDebug.isEnabled || JDebug._level !=1) {
            return;
        }

        if (tag !== 'TAG') tag = `TAG-${tag}`;

        console.log(`[${tag} - Passage ${++JDebug.passOrder}]`, `Level: ${level}`);

        if (resetPassage) {
            JDebug.resetPassOrder();
        }
    }

    static tagLine(lineNum: number = 0, level: LOG_LEVELS = JDebug.DEFAULT_LEVEL, resetPassage: boolean = false): void {
        if (!JDebug.isEnabled || JDebug._level !=1) {
            return;
        }
        let tag: string = "";

        if (lineNum !== 0) tag = `TAG-L${lineNum}`;

        console.log(`[L${tag} - Passage ${++JDebug.passOrder}]`, `Level: ${level}`);

        if (resetPassage) {
            JDebug.resetPassOrder();
        }
    }

    static resetPassOrder(): void {
        JDebug.passOrder = 0;
    }

    static logRecursiveObject(obj: any, label: string = JDebug.DEFAULT_LABEL, level: LOG_LEVELS = JDebug.DEFAULT_LEVEL, depth: number = -1): void {
        if (!JDebug.isEnabled || JDebug._level !=1) {
            return;
        }
        const color: string = getTextColor(level);
        console.log(`%c--- ${label} ---`, `color: ${color}`);
        JDebug.logRecursiveObjectHelper(obj, 0, level, depth);
        console.log('------------------');
    }

    private static logRecursiveObjectHelper(obj: any, currentDepth: number, level: LOG_LEVELS = JDebug.DEFAULT_LEVEL, maxDepth: number): void {
        if (maxDepth !== -1 && currentDepth > maxDepth) {
            return;
        }

        const indent = '  '.repeat(currentDepth);

        Object.keys(obj).forEach((key) => {
            const value = obj[key];

            if (typeof value === 'object' && value !== null) {
                console.log(`${indent}${key}:`);
                JDebug.logRecursiveObjectHelper(value, currentDepth + 1, level, maxDepth);
            } else {
                const logMethod = getLogMethod(level);//  level === LOG_LEVELS.ERROR ? console.error : level === LOG_LEVELS.WARN ? console.warn : console.log;
                logMethod(`${indent}${key}: ${value}`);
            }
        });
    }

}/*END OF CLASS JDEBUG*/


function r(chaine) {
    return chaine.replace(/\n/g, '\\r');
  }
function escapeRegExp(s: string): string {
    return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}
function getLogMethod(level: LOG_LEVELS): (message?: any, ...optionalParams: any[]) => void {
    let logMethod: (message?: any, ...optionalParams: any[]) => void;

    switch (level) {
        case LOG_LEVELS.ERROR:
            logMethod = console.error;
            break;
        case LOG_LEVELS.WARN:
            logMethod = console.warn;
            break;
        case LOG_LEVELS.INFO:
            logMethod = console.log;
            break;
        default:
            logMethod = console.log;
            break;
    }

    return logMethod;
}
function getTextColor(level: LOG_LEVELS): string {
    let color: string;

    switch (level) {
        case LOG_LEVELS.ERROR:
            color = 'red';
            break;
        case LOG_LEVELS.WARN:
            color = 'orange';
            break;
        case LOG_LEVELS.INFO:
            color = 'blue';
            break;
        case LOG_LEVELS.DEBUG:
            color = 'yellow';
            break;
        default:
            color = 'black';
            break;
    }

    return color;
}
